import { render, staticRenderFns } from "./BrandLoginHero.vue?vue&type=template&id=423f9b7a&scoped=true&"
import script from "./BrandLoginHero.vue?vue&type=script&lang=js&"
export * from "./BrandLoginHero.vue?vue&type=script&lang=js&"
import style0 from "./BrandLoginHero.vue?vue&type=style&index=0&id=423f9b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f9b7a",
  null
  
)

export default component.exports